import {
  type PipelineType,
  type PostingSource,
  type ReportTypeEnum,
  type Role,
  type Tab,
  TrialType,
  type User,
} from '@revelio/data-access';

export interface UserOverrides {
  trialType?: TrialType;
  isTrialUser?: boolean;
  live?: boolean;
  clientName?: string;
  expirationDate?: string;
  tourCompleted?: boolean;
  stepsCompleted?: string;
  tourInterestTalentAcquisition?: boolean;
  tourInterestCustomData?: boolean;
  role?: Role;
  tabs?: Tab[];
  linkupPostings?: boolean;
  pipelineTypes?: PipelineType[];
  postingSources?: PostingSource[];
  reportTypes?: ReportTypeEnum[];
}

export interface ImpersonationPreset {
  name: string;
  description: string;
  trialDurationDays?: number;
  overrides: UserOverrides;
}

export interface ImpersonationState {
  isImpersonating: boolean;
  impersonatedUserId: string | null;
  impersonatedUser: Partial<User> | null;
  overrides: UserOverrides | null;
}

export const DEFAULT_IMPERSONATION_STATE: ImpersonationState = {
  isImpersonating: false,
  impersonatedUserId: null,
  impersonatedUser: null,
  overrides: null,
};

export const IMPERSONATION_PRESETS: ImpersonationPreset[] = [
  {
    name: 'CST Trial',
    description:
      '90-day duration, data lagged by 1 year, blurred contact info, no downloads',
    trialDurationDays: 90,
    overrides: {
      trialType: TrialType.ONE_YEAR_DATA_LAG,
      isTrialUser: true,
      live: false,
      tourCompleted: false,
      stepsCompleted: '[]',
    },
  },
  {
    name: 'Free Trial (No Promo)',
    description:
      '7-day duration, no data lag, blurred contact info, no downloads',
    trialDurationDays: 7,
    overrides: {
      trialType: TrialType.NO_DATA_LAG,
      isTrialUser: true,
      live: false,
      tourCompleted: false,
      stepsCompleted: '[]',
    },
  },
  {
    name: 'Free Trial (With Promo)',
    description:
      '30-day duration, no data lag, blurred contact info with manual unblur ability, no downloads',
    trialDurationDays: 30,
    overrides: {
      trialType: TrialType.NO_DATA_LAG_WITH_TD_REVEAL,
      isTrialUser: true,
      live: false,
      tourCompleted: false,
      stepsCompleted: '[]',
    },
  },
];
